import { t } from 'i18next';
import React from 'react';
import { FieldLabel, FieldValue, PatientField, PatientSummary } from '../styled/PatientHistory';

export const PatientInfo = ({ patient }) => {
  const [lastName = '', firstName = ''] = (patient.PatientName || '').split('^');

  return (
    <PatientSummary>
      <PatientField>
        <FieldLabel>{t('patient.id')}</FieldLabel>
        <FieldValue>{patient.PatientID || '—'}</FieldValue>
      </PatientField>
      <PatientField>
        <FieldLabel>{t('patient.name')}</FieldLabel>
        {firstName && <FieldValue>{firstName}</FieldValue>}
        <FieldValue>{lastName || '—'}</FieldValue>
      </PatientField>
      <PatientField>
        <FieldLabel>{t('patient.birthDate')}</FieldLabel>
        <FieldValue>{patient.PatientBirthDate || '—'}</FieldValue>
      </PatientField>
    </PatientSummary>
  );
};

export default PatientInfo;
